import React from 'react'
import { Box, Text } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'

import LeidModal from 'components/ui/Modal/LeidModal'

interface PickupInstructionsModalProps {
  open: boolean
  onClose: () => void
  pickupArticle: Article
}

export const PickupInstructionsModal: React.FC<PickupInstructionsModalProps> = ({ open, onClose, pickupArticle }) => {
  const decodeHtml = (html: string): string => {
    return html.replace(/&lt;iframe[\s\S]*?&lt;\/iframe&gt;/g, (match) => {
      const doc = new DOMParser().parseFromString(match, 'text/html')
      return doc.documentElement.textContent ?? ''
    })
  }
  const decodedPickupHtml = decodeHtml(pickupArticle?.body ?? '')

  return (
    <LeidModal
      isOpen={open}
      onClose={onClose}
      isCentered
      header={
        <Text fontSize="lg" fontWeight="bold">
          {pickupArticle.title}
        </Text>
      }
    >
      <Box minW="300px" maxW="500px" p={4}>
        <div dangerouslySetInnerHTML={{ __html: decodedPickupHtml }} />
      </Box>
    </LeidModal>
  )
}
